module.exports = __webpack_public_path__ + "static/media/hp_2.3c448e0d.svg";